import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Feedback } from '../../interfaces/feedback.model';

@Injectable({ providedIn: 'root' })
export class MessageBannerService {
  private readonly displayBanner = new BehaviorSubject<boolean>(false);
  displayBanner$ = this.displayBanner.asObservable();

  private readonly displayBannerMessage = new BehaviorSubject<Feedback>({});
  displayBannerMessage$ = this.displayBannerMessage.asObservable();

  showBanner(): void {
    this.displayBanner.next(true);
  }

  hideBanner(): void {
    this.displayBanner.next(false);
  }

  setMessage(alert: Feedback): void {
    this.displayBannerMessage.next(alert);
  }
}
